import type { Bucket, BucketAcl } from '@/entities/bucket';
import request from '@/shared/api/request';

export const createBucket = (data: {
  name: string;
  region: string;
  acl: BucketAcl;
  project_uuid?: string;
}): Promise<{ bucket: Bucket }> =>
  request({
    url: '/buckets/',
    method: 'POST',
    data,
  });
